<p-panel class="p-2">
  <ng-template #header>
    <h1>Benutzerinformationen</h1>
  </ng-template>
  <div class="flex flex-col gap-4">
    <div class="flex flex-col gap-1">
      <p><strong>Benutzername:</strong> {{ activeUser?.name }}</p>
      <p><strong>Token:</strong> {{ activeUser?.token }}</p>
      <p><strong>Rollen:</strong> {{ activeUser?.roles }}</p>
      <p><strong>Standard-Tierheim:</strong> {{ activeUser?.defaultAnimalShelter?.id }}</p>
    </div>

    <hr class="border-gray-200">

    <div class="flex flex-col gap-3">
      <h2 class="m-0 text-base font-semibold text-gray-700">Anzeigename ändern</h2>
      <div class="flex flex-col gap-1">
        <label for="displayName" class="text-sm font-medium text-gray-600">Anzeigename</label>
        <div class="flex gap-2">
          <input
            id="displayName"
            type="text"
            pInputText
            [(ngModel)]="newDisplayName"
            placeholder="Anzeigename eingeben"
            class="flex-1">
          <p-button
            label="Speichern"
            icon="pi pi-save"
            [loading]="isSaving"
            [disabled]="!newDisplayName.trim()"
            (onClick)="saveDisplayName()">
          </p-button>
        </div>
      </div>
    </div>
  </div>
</p-panel>
